import React, { useContext } from 'react';
import { shape, func } from 'prop-types';
import { ExperienceContext, useStore } from '@thd-nucleus/experience-context';
import { Alert } from '@thd-olt-component-react/alert';
import {
  getNearbyStoreWithLimitedStock, formatDistance, productShape
} from '../../helpers/pod-fulfillment-utils';
import { CheckNearByStore } from './CheckNearbyStore';

export const LimitedAvailabilityNearby = ({
  product,
  onCheckNearbyStoresClick
}) => {
  const {
    channel
  } = useContext(ExperienceContext);
  const { storeId } = useStore();

  if (!(product && storeId)) {
    return null;
  }

  const nearbyStore = getNearbyStoreWithLimitedStock(product);

  if (!nearbyStore) {
    return null;
  }

  const { locationId, storeName, distance, storePhone } = nearbyStore;

  if (!(storeName && distance)) {
    return null;
  }

  return (
    <>
      <Alert type="warning" message="Limited stock at nearby store" inline />

      <div className="store__new-line">
        {storeName} | {formatDistance(distance)} miles away
      </div>
      {channel !== 'mobile' && (
        <div className="store__new-line">
          <CheckNearByStore
            product={product}
            onCheckNearbyStoresClick={onCheckNearbyStoresClick}
          />
        </div>
      )}
    </>
  );
};

LimitedAvailabilityNearby.propTypes = {
  product: shape({ productShape }).isRequired,
  onCheckNearbyStoresClick: func,
};

LimitedAvailabilityNearby.defaultProps = {
  onCheckNearbyStoresClick: null
};
